<script setup lang="ts">
import { computed } from 'vue'
// types
import type { StrapiFooterInfoItem } from '@ts-strapi/interfaces'
// hooks
import { useFooterBottomRow } from '@composables/widgets/footers/footer-bottom-row.hook'
// components
import { AppText, AppTextLink } from '@UI/Typography/AppText'

defineOptions({
  name: 'FooterBottomRow',
})

const props = defineProps<{
  items: StrapiFooterInfoItem[]
  variant: 'mobile' | 'desktop'
}>()

const refItemsProp = computed<StrapiFooterInfoItem[]>(() => props.items)

const { refResolved, refLead, refRest } = useFooterBottomRow({
  items: refItemsProp,
})

const refVariantClass = computed<string>(() => `footer-bottom-row--${props.variant}`)
</script>

<template>
  <div
    class="footer-bottom-row"
    :class="refVariantClass"
  >
    <template v-if="variant === 'mobile'">
      <template
        v-for="(item, index) in refResolved"
        :key="index"
      >
        <AppTextLink
          v-if="item.url"
          :href="item.url"
          :target="item.newTab ? '_blank' : undefined"
          name="body4"
          color="white"
        >
          {{ item.text }}
        </AppTextLink>
        <AppText
          v-else
          tag="span"
          name="body4"
          color="white"
        >
          {{ item.text }}
        </AppText>
        <span
          v-if="index < refResolved.length - 1"
          class="footer-bottom-row__sep"
        >·</span>
      </template>
    </template>

    <template v-else>
      <div class="footer-bottom-row__lead">
        <template v-if="refLead">
          <AppTextLink
            v-if="refLead.url"
            :href="refLead.url"
            :target="refLead.newTab ? '_blank' : undefined"
            name="body4"
            color="white"
          >
            {{ refLead.text }}
          </AppTextLink>
          <AppText
            v-else
            tag="span"
            name="body4"
            color="white"
          >
            {{ refLead.text }}
          </AppText>
        </template>
      </div>

      <div class="footer-bottom-row__rest">
        <template
          v-for="(item, index) in refRest"
          :key="index"
        >
          <AppTextLink
            v-if="item.url"
            :href="item.url"
            :target="item.newTab ? '_blank' : undefined"
            name="body4"
            color="white"
          >
            {{ item.text }}
          </AppTextLink>
          <AppText
            v-else
            tag="span"
            name="body4"
            color="white"
          >
            {{ item.text }}
          </AppText>
          <span
            v-if="index < refRest.length - 1"
            class="footer-bottom-row__sep"
          >·</span>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Footers/FooterBottomRow.scss" />